export default __webpack_public_path__ + "static/media/img-slider-scb-anywhere-4.b071fcb1.png";